module.exports = __webpack_public_path__ + "img/header-bg.c7cceb1b.jpg";